import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { PowerResponse } from '../interfaces/beans.interface'
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

class PowersOfAttorney {
  // id: string ='';
  name: string ='';
  created_at: Date; 
  reciver: Reciver = new Reciver(); 
  society: Society = new Society(); 
  start_at: Date;
  end_at: Date;
  limits: string;
  comments: string;
  type: string;
  extension: string;
  attribute: [][] = []; 
  taxid: string;
}

class Reciver {
  tax_id: string ='';
  name: string ='';
}

class Society {
  tax_id: string ='';
  name: string ='';
}

@Injectable({
  providedIn: 'root'
})
export class PowersAttorneyService {

  private baseUrl = environment.url2;

  constructor(private http: HttpClient) { }


  // save(data: any){
  //   const headers = new HttpHeaders()
  //   // .append( 'Content-Type', 'application/json; charset=UTF-8')
  //   .append('Autorizzazione', localStorage.getItem('token')); // Add the 'Autorizzazione' header

  //   const formData: FormData = new FormData();
  //   formData.append('reciver_name',data.name);
  //   formData.append('society',data.society);
  //   formData.append('type',data.type);
  //   formData.append('extension',data.extension);
  //   formData.append('attributes',data.attributes);
  //   formData.append('limits',data.limits);
  //   formData.append('comments',data.comments);
  //   formData.append('start_at',data.start_at);
  //   formData.append('end_at',data.end_at);
  //   formData.append('owner_taxt_id',localStorage.getItem('userTaxId'));



  //   const req = new HttpRequest('POST', `${this.baseUrl}/powers-attorney/`, formData, {
  //     reportProgress: true,
  //     responseType: 'json',
  //     headers: headers
  //   });

  //   return this.http.request(req);
  // }

  save (powersOfAttorney: PowersOfAttorney): Observable<any> {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    // return this.http.post<PowersOfAttorney>(`${this.baseUrl}/powers-attorney/`, powersOfAttorney);
    return this.http.post(`${this.baseUrl+'/'+'powers-attorney'}/`, powersOfAttorney, { headers }).pipe( map( data => data));
  }

  list (powersOfAttorneyId: string): Observable<any> {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    let params = new HttpParams().set('id', powersOfAttorneyId);
    // return this.http.post<PowersOfAttorney>(`${this.baseUrl}/powers-attorney/`, powersOfAttorney);
    return this.http.get(`${this.baseUrl+'/'+'powers-attorney'}/list`,{ headers,params }).pipe( map( data => data));
  }

  deleteById(id: string): Observable<void> {
    const headers = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.delete<void>(`${this.baseUrl}/powers-attorney/${id}`, { headers });
  }

  /** kind: tenancy | original | registered — matches GET /powers-attorney/{id}/document/{kind} */
  getPowerDocument(powerId: string, kind: 'tenancy' | 'original' | 'registered') {
    const headers = new HttpHeaders()
      .append('Autorizzazione', localStorage.getItem('token') || '');
    return this.http.get(
      `${this.baseUrl}/powers-attorney/${powerId}/document/${kind}`,
      { headers, responseType: 'blob', observe: 'response' }
    );
  }

}
